module.exports = __webpack_public_path__ + "img/arrow.5004c35a.svg";